import { render, staticRenderFns } from "./examDeclareManager.vue?vue&type=template&id=69fb9752"
import script from "./examDeclareManager.vue?vue&type=script&lang=js"
export * from "./examDeclareManager.vue?vue&type=script&lang=js"
import style0 from "./examDeclareManager.vue?vue&type=style&index=0&id=69fb9752&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports